module.exports = __webpack_public_path__ + "img/person2.9a1336f1.jpg";